<template>
  <div class="va-row">
    <div class="flex md12 xs12" v-if="isAdmin">
      <vuestic-widget>
        <div class="va-row">
          <div class="flex md4">
            <button class="btn btn-primary btn-sm" @click="jumpToNewAppPage">
              <div class="btn-with-icon-content">
                <i class="ion-md-add-circle ion"></i>
                {{ "basic.button.new" | translate }}
              </div>
            </button>
          </div>
        </div>
      </vuestic-widget>
    </div>
    <div class="flex xs12 md12 w-table">
      <vuestic-widget id="datagridApp">
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>{{ "tables.apping.appName" | translate }}</th>
                <th>{{ "tables.apping.appId" | translate }}</th>
                <th>{{ "tables.apping.country" | translate }}</th>
                <th>{{ "tables.apping.createDate" | translate }}</th>
                <th>{{ "tables.apping.status" | translate }}</th>
                <th align="right">{{ "tables.apping.actions" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(val, index) in applist" :key="index">
                <td @click="viewFun(val.app_id)"
                  class="action-color-1"
                >
                  {{ val.app_name }}
                </td>
                <td>{{ val.app_id }}</td>
                <td>{{ queryCountry(val.region) }}</td>
                <td>{{ val.create_time }}</td>
                <td>{{ val.status == 0 ? $t('statusLabel.disable') : $t('statusLabel.enable') }}</td>
                <td align="right">
                  <router-link
                    :to="{
                      name: 'EditAppInfo',
                      params: { app_id: val.app_id }
                    }"
                    ><span class="action-color-1">{{ $t("config") }}</span></router-link
                  >
                  <span class="action-color-1"></span>
                </td>
              </tr>
            </tbody>
          </table>
          <Spinner style="margin: 30px auto" v-if="isLoading" size="small" />
        </div>
        <div class="block"></div>
      </vuestic-widget>
    </div>
  </div>
</template>

<script>
import FilterBar from "@/vuestic-theme/vuestic-components/vuestic-datatable/datatable-components/FilterBar.vue";
import { request, queryCountryByCode } from "@/utils/utils";
import Spinner from "vue-simple-spinner";
export default {
  name: "UserManagement",
  components: { FilterBar, Spinner },
  data() {
    return {
      applist: [],
      allRegions: [],
      isLoading: false
    };
  },
  created() {
    this.isLoading = true;
    this.initDropdown();
    this.drawAppTable();
  },
  computed: {
    isAdmin: function() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        const { data } = userInfo.info
        if (data.role === 'MERCHANT_ADMIN') {
          return true
        }
        return false
      } catch (error) {
        return false
      }
    }
  },
  methods: {
    jumpToNewAppPage() {
      this.$router.push({
        name: "NewApp"
      });
    },
    viewFun(appId) {
      this.$router.push({
        name: "ViewAppInfo",
        params: { app_id: appId }
      });
    },
    initDropdown() {
      let token = localStorage.getItem("Authorization");
      let url = "/api/dashboard/basic/getDropdown?access_token=" + token;
      request({
        method: "post",
        url
      }).then(res => {
        this.allRegions = res.data.regions;
        this.isLoading = false;
      });
    },
    queryCountry(code) {
      for (let i = 0; i < this.allRegions.length; i++) {
        if (this.allRegions[i].code === code) {
          return this.allRegions[i].name || queryCountryByCode(code);
          break;
        }
      }
    },
    drawAppTable() {
      let token = localStorage.getItem("Authorization");
      let urls = "api/dashboard/merchant/getMerchantInfo?access_token=" + token;
      request({
        method: "post",
        url: urls
      }).then(res => {
        this.applist = res.data.app_list;
      });
    }
  }
};
</script>

<style>
.table th {
  text-align: center;
}

.table td {
  text-align: center;
}

#searchBar {
  height: 50px;
}
@media only screen and (max-width: 750px) {
  #datagridApp.vuestic-widget .vuestic-widget-body {
    padding: 0.2rem;
  }
}
</style>

<style lang="scss">
  .action-color-1 {
    color: $action-color;
    cursor:pointer;
  }
</style>
